import { ReactNode } from 'react'
import { Control, Controller, FieldValues, Path } from 'react-hook-form'

import { WidgetChoice } from '@/common/form/choice'

import CheckBox, { CheckBoxType } from '@/components/view/atoms/checkbox/CheckBox'

interface Props<T extends FieldValues> {
  control: Control<T>
  name: Path<T>
  choices: WidgetChoice<number | string>[]
  incomplete?: boolean
  forDisclosure?: boolean
  forRow?: boolean
  labelNode?: ReactNode
  nowrap?: boolean
  disabled?: boolean
}

const FormCheckBoxes = <T extends FieldValues>({
  control,
  name,
  choices,
  incomplete = false,
  forDisclosure,
  forRow,
  labelNode,
  nowrap = false,
  disabled = false
}: Props<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        return (
          <>
            {choices.map((choice) => (
              <CheckBox
                key={choice.value}
                type={CheckBoxType.CHECK}
                label={choice.name}
                name={field.name}
                checked={field.value.includes(choice.value)}
                disabled={disabled || !!choice.disabled}
                incomplete={incomplete}
                forDisclosure={forDisclosure}
                forRow={forRow}
                labelNode={labelNode}
                onChange={(checked) => {
                  field.onChange(
                    checked
                      ? [...field.value, choice.value]
                      : field.value.filter((value: string) => value != choice.value)
                  )
                }}
                nowrap={nowrap}
                block
              />
            ))}
          </>
        )
      }}
    />
  )
}

export default FormCheckBoxes
